<template>
    <v-container fluid fill-height class="sidebar">
      <v-layout @click="animSidebar" class="rightTab">
        <v-flex class="rightTabButton">
          <div class="tripleCircle"></div>
          <div class="tripleCircle"></div>
          <div class="tripleCircle"></div>
        </v-flex>
      </v-layout>
       <v-layout>
        <v-flex align-self-start>
            <sidebar />
        </v-flex>  
       </v-layout>     
    </v-container>
</template>


/--------------------------------------------------
<script>
import sidebar from "@/components/portal/layout/Sidebar";
import animations from "@/assets/scripts/animations";

export default {
  components: {
    sidebar
  },
   mixins:[animations] 
};
</script>


<style lang="scss">
.sidebar{
    background-color: var(--grey-dark);
}
.sidebarTop, .sidebarCenter, .sidebarBottom{
    padding: 0 var(--gutter) 0 var(--gutter);
    text-align: center;
}
.sidebarTop{
    height: var(--breadcrumbs-height);
}
.sidebarTop h4, .sidebarCenter h4{
    color: var(--white);
}
.sidebarTop p{
    color: var(--blue-medium);
    margin: 0;
}

.rightTab{
    width: 20px;
    height: 48px;
    position: absolute;
    top: calc(50% - 72px);
}
.tripleCircle{
    width: 8px;
    height: 8px;
    margin: 6px;
    border-radius: 50%;
    background-color: var(--grey-medium);
}
.rightTabButton{
    width: 20px;
    height: 48px;
    flex: none;
    cursor: pointer;
}
.rightTabButton:hover > .tripleCircle{
    background-color: var(--blue-light);
}
</style>
